export const DAYS = [
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница'
]

export const FLIP_DURATION_MS = 150

export const BACKLOG_DEFAULT_STATE = [
    'datesAgreement',
    'colleaguesVacations',
    'leaveApplication'
]

export const WEEK_DEFAULT_STATE = {
    currentDay: 0,
    lastStep: null,
    items: {}
}

export const UNIVERSAL_ENDING = `К сожалению, вы не успели отправить заявление в рабочее время и HR-специалист уже ушёл. А в понедельник будет уже поздно, в компании строго соблюдают правило, что отпуск должен быть написан за 14 календарных дней. Так что самолёт улетит без вас.<br/>
Желаем, чтобы в вашей компании появился EmployeeGate, ведь с ним всё гораздо быстрее: не нужно искать шаблон заявления и высчитывать дату подачи — всё просто заполняется в личном кабинете. А ещё вы всегда видите, кто замещает руководителя, а руководители видят график отпусков своих подчинённых.
`